export const ganttPaths = {
  INDEX: '/',
}
